import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from '../themes/ThemeProvider';
export const FooterLinks = ({ children, separator, className, style, ...props }) => {
    const theme = useTheme();
    const items = React.Children.toArray(children).filter(Boolean);
    const defaultSeparator = (_jsx("span", { style: {
            width: 1,
            height: 8,
            background: theme.footerLinksSeparatorColor ?? '#1F1F1F',
            opacity: 0.3,
            display: 'inline-block',
            margin: '0 8px',
        } }));
    return (_jsx("div", { className: className, style: {
            display: 'flex',
            alignItems: 'center',
            gap: 0,
            ...style,
        }, ...props, children: items.map((child, idx) => (_jsxs(React.Fragment, { children: [child, idx < items.length - 1 && (separator ?? defaultSeparator)] }, idx))) }));
};
